import { render, staticRenderFns } from "./recommendLinkDialog.vue?vue&type=template&id=588a0008&scoped=true"
import script from "./recommendLinkDialog.vue?vue&type=script&lang=js"
export * from "./recommendLinkDialog.vue?vue&type=script&lang=js"
import style0 from "./recommendLinkDialog.vue?vue&type=style&index=0&id=588a0008&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588a0008",
  null
  
)

export default component.exports